import httpClient from '~/lib/http-client';
import type { UserPreferences, UserProfile } from '@shared/types/user-settings';

export async function apiGetPreferences(): Promise<UserPreferences> {
  const { data } = await httpClient.get<UserPreferences>('/api/user-settings/preferences');
  return data;
}

export async function apiUpdatePreferences(patch: Partial<UserPreferences>): Promise<UserPreferences> {
  const { data } = await httpClient.put<UserPreferences>('/api/user-settings/preferences', patch);
  return data;
}

export async function apiGetProfile(): Promise<UserProfile> {
  const { data } = await httpClient.get<UserProfile>('/api/user-settings/profile');
  return data;
}

export async function apiUpdateProfile(updates: Partial<UserProfile>): Promise<UserProfile> {
  const { data } = await httpClient.put<UserProfile>('/api/user-settings/profile', updates);
  return data;
}
